import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Dock } from 'contracts/Docks';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_DOCK_',
  }
);

export interface FetchDockState {
  data: Dock | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchDockRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Dock;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchDockState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchDockState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchDockState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchDockState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchDockState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchDock = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchDockTypes = Types;
export const FetchDockActions = Creators;
